export const enum RouteAuth {
  callback = 'callback',
  sessionClosed = 'session-closed',
}
